import styled from 'styled-components';

export const List = styled.ul`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);
  width: 100%;
`;

export const Item = styled.li`
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  gap: var(--spacing-base);
  padding-block-end: var(--spacing-large);
  border-block-end: 1px solid var(--grey-200);

  @media (width >= 48rem) {
    gap: var(--spacing-large);
  }

    & a { 
        height: fit-content;
  } 
`;

export const ItemContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-large);

  @media (width >= 48rem) {
    flex-direction: row;
  }
`;

export const Description = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xsmall);
`;

export const Title = styled.div`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-semibold);
`;

export const TitleLink = styled.a`
  color: var(--foreground-color);
  text-decoration: none;
  font-weight: var(--font-weight-semibold);

  &:hover {
        text-decoration: underline;
        text-decoration-color: var(--grey-600);
        text-underline-offset: 3px;
        color: var(--grey-600);
  }
`;

export const Price = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacing-small);
  padding-block-end: var(--spacing-large);

  & .currentPrice {
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-semibold);
  }

  & .formerPrice {
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-regular);
    color: var(--grey-500);
    text-decoration: line-through;
  }
`;

export const ByLine = styled.div`
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-medium);
  color: var(--grey-500);
`;

export const PendingWrapper = styled.div<{ $isPending: boolean }>`
  position: relative;
  pointer-events: ${({ $isPending }) => ($isPending ? 'none' : 'auto')};
`;

export const SpinnerOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.6);
`;

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--spacing-base);

  @media (width >= 48rem) {
    align-items: flex-end;
    margin-block-start: -0.5rem;
  }
`;
